import { createRouter, createWebHistory } from "vue-router";

import { requireAuth } from "@/auth";

const LogoutPage = () => import("@/views/LogoutPage.vue");
const SimulatorPage = () => import("@/views/SimulatorPage.vue");
const ConfigurationLayout = () => import("@/components/configuration/ConfigurationLayout.vue");
const AppLayout = () => import("@/components/layout/AppLayout.vue");
const CwdsLayout = () => import("@/components/layout/CwdsLayout.vue");
const AboutPage = () => import("@/views/AboutPage.vue");
const ConfigurationGate = () => import("@/views/ConfigurationGate.vue");
const ConfigurationLut = () => import("@/views/ConfigurationLut.vue");
const DevPage = () => import("@/views/DevPage.vue");
const DummyPage = () => import("@/views/DummyPage.vue");
const GateAssignmentHistory = () => import("@/views/GateAssignmentHistory.vue");
const GateAssignmentList = () => import("@/views/GateAssignmentList.vue");
const HomePage = () => import("@/views/HomePage.vue");
const NotFound = () => import("@/views/NotFound.vue");
const SiteHomePage = () => import("@/views/SiteHomePage.vue");
const TripReleasePage = () => import("@/views/TripReleasePage.vue");
const WhoAmIPage = () => import("@/views/WhoAmIPage.vue");

const Dashboard = () => import("../views/DashboardPage.vue");
const JsonMapPage = () => import("../views/JsonMapPage.vue");
const PlanningPage = () => import("../views/PlanningPage.vue");
const TripGraphPage = () => import("../views/TripGraph.vue");
const TripHistoryPage = () => import("../views/TripHistoryPage.vue");
const StagingProgressPage = () => import("../views/StagingProgress.vue");

export const ROUTE_SITE_HOME = "SiteHome";
export const ROUTE_ROOT = "root";
export const ROUTE_GRAPH = "graph";
export const ROUTE_STAGING_PROGRESS = "RouteStagingProgress";
export const ROUTE_CONFIGURATION = "configuration";
export const ROUTE_CONFIGURATION_LUT = "ConfigurationLut";
export const ROUTE_CONFIGURATION_GATE = "ConfigurationGate";
export const ROUTE_SIMULATOR = "RouteSimulator";

export const ROUTE_TRIP = "trip";
export const ROUTE_TRIP_RELEASE = "TripRelease";
export const ROUTE_TRIP_HISTORY = "TripHistory";

export const ROUTE_GATE_ASSIGNMENT = "GateAssignment";
export const ROUTE_GATE_ASSIGNMENT_LIST = "GateAssignmentList";
export const ROUTE_GATE_ASSIGNMENT_HISTORY = "GateAssignmentHistory";

export const ROUTE_DASHBOARD = "dashboard";
export const ROUTE_PLANNING = "planning";

const routes = [
  {
    name: "buRoot",
    path: "/control/:buCode",
    beforeEnter: requireAuth,
    // TODO rename this to BuLayout
    component: AppLayout,
    children: [
      { name: ROUTE_SITE_HOME, path: "", component: SiteHomePage },
      {
        name: ROUTE_TRIP,
        path: "trip",
        redirect: { name: ROUTE_TRIP_RELEASE },
        children: [
          { name: ROUTE_TRIP_RELEASE, path: "release", component: TripReleasePage },
          { name: ROUTE_TRIP_HISTORY, path: "history", component: TripHistoryPage },
        ],
      },
      {
        name: ROUTE_GATE_ASSIGNMENT,
        path: "ga",
        redirect: { name: ROUTE_GATE_ASSIGNMENT_LIST },
        children: [
          { name: ROUTE_GATE_ASSIGNMENT_LIST, path: "list", component: GateAssignmentList },
          {
            name: ROUTE_GATE_ASSIGNMENT_HISTORY,
            path: "history",
            component: GateAssignmentHistory,
          },
        ],
      },
      {
        name: ROUTE_SIMULATOR,
        path: "sim",
        component: SimulatorPage,
      },
      {
        name: ROUTE_STAGING_PROGRESS,
        path: "staging/progress/:tripId",
        component: StagingProgressPage,
      },
      { name: ROUTE_GRAPH, path: "graph", component: TripGraphPage },
      { name: ROUTE_PLANNING, path: "planning", component: PlanningPage },
      { name: "jsonMap", path: "json-map", component: JsonMapPage },
      {
        name: ROUTE_CONFIGURATION,
        path: "configuration",
        component: ConfigurationLayout,
        redirect: { name: ROUTE_CONFIGURATION_LUT },
        children: [
          { name: ROUTE_CONFIGURATION_LUT, path: "lut", component: ConfigurationLut },
          { name: ROUTE_CONFIGURATION_GATE, path: "gate", component: ConfigurationGate },
        ],
      },
      { name: ROUTE_DASHBOARD, path: "dashboard", component: Dashboard },
      { path: ":pathMatch(.*)", name: "not-found", redirect: "buRoot" },
    ],
  },

  { name: ROUTE_ROOT, path: "/", beforeEnter: requireAuth, component: HomePage },
  { name: "whoami", path: "/whoami", beforeEnter: requireAuth, component: WhoAmIPage },
  { name: "dev", path: "/dev", beforeEnter: requireAuth, component: DevPage },
  {
    name: "logout",
    path: "/logout",
    component: LogoutPage,
  },
  {
    name: "about",
    path: "/about",
    beforeEnter: requireAuth,
    component: CwdsLayout,
    children: [{ name: "AboutHome", path: "", component: AboutPage }],
  },
  { name: "AuthCallback", path: "/auth/callback", component: DummyPage },
  import.meta.env.MODE === "development"
    ? {
        path: "/_ui",
        beforeEnter: requireAuth,
        children: [
          { path: "form", component: () => import("@/views/ui/FormPreviewPage.vue") },
          { path: "accordion", component: () => import("@/views/ui/AccordionPreviewPage.vue") },
        ],
      }
    : undefined,
  import.meta.env.MODE === "development"
    ? {
        path: "/_dev",
        children: [
          { path: "auth", component: () => import("@/views/dev/DevAuth.vue") },
          { path: "skapa", component: () => import("@/views/dev/SkapaPreview.vue") },
          { path: "planning", component: () => import("@/views/dev/DevPlanning.vue") },
        ],
      }
    : undefined,
  { path: "/:pathMatch(.*)", name: "not-found", component: NotFound },
].filter((x) => !!x);

export default createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});
